export const numberFormat = number => {
  const formater = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2
  }).format(number);
  return formater;
};

export const getDueTime = dueDate => {
  const dueTime = new Date(dueDate).getTime();
  const now = new Date().getTime();

  const diff = dueTime - now;
  if (diff < 0) {
    return 'Fee is due';
  }

  let sec = diff / 1000;
  let hour = sec / 3600;
  let days = hour / 24;

  if (sec < 60) {
    return `Due in ${Math.floor(sec)} seconds`;
  } else if (hour <= 24) {
    return `Due in ${Math.floor(hour)} hours`;
  } else if (Math.floor(days) <= 30) {
    return `Due in ${Math.floor(days)} days`;
  } else {
    return `Due ${dueDate}`;
  }
};

export const groupCoursesToSems = courses => {
  courses = courses.filter(course => course !== null);
  let coursesPerSem = courses.reduce((courseObj, course, index) => {
    let courseSem = parseInt(course.semester) === 1 ? 'first' : 'second';
    if (!courseObj[courseSem]) {
      courseObj[courseSem] = [];
    }
    courseObj[courseSem].push(course);
    return courseObj;
  }, {});
  let { first, second } = coursesPerSem;
  first = first || [];
  second = second || [];
  coursesPerSem.first = first.sort((course1, course2) => {
    if (course1.is_registered && !course2.is_registered) { return -1 }
    if (!course1.is_registered && course2.is_registered) { return 1 }

  });
  coursesPerSem.second = second.sort((course1, course2) => {
    if (course1.is_registered && !course2.is_registered) { return -1 }
    if (!course1.is_registered && course2.is_registered) { return 1 }

  }); return coursesPerSem;
};

export const canDisableFee = (feeToCheck, fees) => {
  /* filter the fees to return the fee whose payment_code is equal to the prerequisite_fee
        if the prerequisite fee is not found return true;
    */

  if (Number(feeToCheck.is_active) === 0) return true;

  // if fees is not passed abort operations on fees to avoid errors
  if (!fees) return false;

  if (feeToCheck.prerequisite_fee === null) return false;
  const prerequisiteNotFound =
    fees.filter(fee => fee.payment_code === feeToCheck.prerequisite_fee)
      .length === 0;
  if (prerequisiteNotFound) return prerequisiteNotFound;

  /* filter the fees to return the fee whose payment_code is equal to the prerequisite_fee
        use the array#reduce to reduce it to a Boolean corresponding to if fee.paid === 0;
    */
  return fees
    .filter(fee => fee.payment_code === feeToCheck.prerequisite_fee)
    .reduce((acc, curr) => {
      return curr.paid === 0;
    }, false);
};
